import { render, staticRenderFns } from "./edit-gallery.vue?vue&type=template&id=f6cead6a&scoped=true&"
import script from "./edit-gallery.vue?vue&type=script&lang=ts&"
export * from "./edit-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./edit-gallery.vue?vue&type=style&index=0&id=f6cead6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cead6a",
  null
  
)

export default component.exports